<template>
  <div v-if="questionnaire">
    <form @submit.prevent>
      <slot name="actions"></slot>
      <k-questionnaire-prompt
        ref="prompt"
        v-for="prompt in questionnaire.prompts"
        :key="prompt.id"
        :prompt="prompt"
        :previous-response="getPreviousResponse(prompt.id)"
        :read-only="readOnly"
        @update="updateResponse(prompt.id, $event)"
        :disable-text-toolbar="disableTextToolbar"
      ></k-questionnaire-prompt>
      <slot name="bottom-actions"></slot>
    </form>
  </div>
</template>

<script>
import TimeMixin from '@mixins/time-mixins';
import copyObject from '@utils/copy-object';
import KQuestionnairePrompt from './k-questionnaire-prompt.vue';

export default {
  components: {
    KQuestionnairePrompt,
  },

  mixins: [TimeMixin],

  props: {
    questionnaire: {
      type: Object,
    },
    latestSubmission: {
      type: Object,
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
    disableTextToolbar: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      currentResponses: {},
    };
  },

  computed: {
    previousResponses() {
      return this.latestSubmission?.responses;
    },
  },

  methods: {
    getPreviousResponse(promptId) {
      return this.previousResponses?.find(x => x.prompt_id === promptId)?.response;
    },
    updateResponse(promptId, response) {
      this.currentResponses[promptId] = response;
      if (!this.readOnly) {
        this.$emit('edited');
      }
    },
    formatResponse(val, promptId) {
      if (val === undefined || val === null) {
        return val;
      }
      const promptType = this.questionnaire.prompts.find(x => x.id === promptId)?.response_type;
      if (promptType === 'QUANTITATIVE_PERCENT' || promptType === 'QUANTITATIVE_VALUE') {
        return parseInt(val, 10);
      }
      if (promptType === 'MULTIPLE_CHOICE') {
        // If response to multi choice is an empty array, turn it into a null
        // so it doesn't count towards completion percentage
        return val?.length > 0 ? val : null;
      }
      return val;
    },
    getSubmitPayload() {
      const mergedResponses = {};
      this.questionnaire.prompts.forEach(prompt => {
        const promptId = prompt.id;
        if (Object.prototype.hasOwnProperty.call(this.currentResponses, promptId)) {
          mergedResponses[promptId] = this.currentResponses[promptId];
        } else {
          const previousResponse = this.getPreviousResponse(promptId);
          if (previousResponse !== undefined) {
            mergedResponses[promptId] = previousResponse;
          }
        }
      });
      const payload = {
        responses: Object.entries(copyObject(mergedResponses)).map(x => ({
          prompt_id: parseInt(x[0], 10),
          response: this.formatResponse(x[1], parseInt(x[0], 10)),
        })).filter(x => x.response !== undefined && x.response !== null && x.response !== ''), // 0 is allowed
      };
      return payload;
    },
    clearResponses() {
      this.$emit('reset');
      this.$emit('disabling-submission');
      this.$refs.prompt.map(p => p.clearResponse());
      this.$emit('enable-submission');
    },
  },
};
</script>
